<template>
    <footer
        v-if="numberOfSuppliers"
        :class="[
            'footer animate__animated',
            numberOfSuppliers ? 'animate__slideInUp animate__faster' : 'animate__slideOutDown',
        ]"
    >
        <div v-if="isMobile" class="display-mobile">
            <div @click="openWindow = !openWindow" class="switch-mobile">
                <font-awesome-icon :icon="['fas', arrow]" />
            </div>
        </div>
        <div :class="[isMobile ? 'content-mobile' : 'content-page', 'container', isMobile ? '' : 'justify-between']">
            <div v-if="isMobile && !openWindow"></div>
            <div
                v-else
                :class="
                    isMobile
                        ? 'supplier-list-container-mobile animate__animated animate__slideInRight animate__faster'
                        : 'supplier-list-container'
                "
            >
                <div v-for="(supplier, index) in suppliers" :key="supplier.uuid" class="supplier-box">
                    {{ supplier.tradingName }}
                    <span @click="$emit('remove-supplier', index)" class="icon">
                        <i class="fas fa-times"></i>
                    </span>
                </div>
            </div>
            <div>
                <eg-button @click="goToNewCompetition" :class="[isMobile ? 'mobile-btn' : '']" variant="eg-yellow">
                    {{ selectedSupplier ? 'Enviar Convites' : 'Solicitar Orçamentos' }}
                    <span class="number-of-suppliers">{{ numberOfSuppliers }}</span>
                </eg-button>
            </div>
        </div>
    </footer>
</template>

<script>
import { addSuppliersInStructeredCompetition } from '@/services';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'SupplierBudget',
    props: {
        suppliers: Array,
        isMobile: Boolean,
        selectedSupplier: Boolean,
        competitionId: [Number, String]
    },
    data: () => ({
        openWindow: false
    }),
    methods: {
        ...mapActions('notification', ['showNotification']),
        ...mapActions('supplierNetwork', ['clearSuppliers', 'saveCompetitionId', 'saveMagicLink']),
        async goToNewCompetition() {
            try {
                if (this.selectedSupplier) {
                    const suppliers = this.suppliers.map(suplier => suplier.uuid);
                    await addSuppliersInStructeredCompetition(this.competitionId, { suppliers });
                    const text = `Fornecedor${this.numberOfSuppliers > 1 ? 'es' : ''} convidado${
                        this.numberOfSuppliers > 1 ? 's' : ''
                    } com sucesso`;
                    this.showNotification({ text, type: 'success' });
                    this.clearSuppliers();
                    this.saveCompetitionId(0);
                    this.magickLinkAction();
                } else {
                    this.$router.push({ name: 'StructuredQuote' });
                }
            } catch (e) {
                this.$router.push({ name: 'LandingPage' });
            }
        },
        magickLinkAction() {
            if (this.contractorProfile && this.hasContractorProfile) {
                this.$router.push({ name: 'Login' });
            } else {
                if (this.magicLink) {
                    this.$router.push({ name: 'MagicLink', query: { sesame: this.magicLink } });
                    this.saveMagicLink('');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            }
        }
    },
    computed: {
        ...mapState('supplierNetwork', ['supplierList', 'magicLink']),
        ...mapState('user', ['user']),
        contractorProfile() {
            return this.user.type && this.user.type.contractorType;
        },
        hasContractorProfile() {
            return this.user.type && this.user.type.hasContractorProfile;
        },
        numberOfSuppliers() {
            return this.suppliers.length;
        },
        arrow() {
            return this.openWindow ? 'chevron-down' : 'chevron-up';
        }
    }
};
</script>

<style lang="scss" scoped>
.footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #0e3d74;
    box-shadow: 0px -3px 16px rgba(0, 0, 0, 0.25);
    z-index: 2;

    margin-left: -5%;
}
.number-of-suppliers {
    background: #f7912c;
    border-radius: 50%;
    padding-inline: 6px;
}
.content-page {
    display: flex;
    padding-top: 35px;
    padding-bottom: 35px;
}
.content-mobile {
    padding-top: 20px;
    padding-bottom: 20px;
    display: grid;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.supplier-list-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
.supplier-list-container-mobile {
    display: flex;
    width: auto;

    overflow: auto;
    margin-bottom: 13px;

    flex-grow: 1;
}
.icon {
    padding-left: 8px;
    cursor: pointer;
}
.mobile-btn {
    width: 100%;
    display: flex;
}
.display-mobile {
    display: flex;
    justify-content: center;
}
.switch-mobile {
    background: #194371;
    color: white;
    border-radius: 50%;
    box-shadow: 0px -3px 16px rgba(0, 0, 0, 0.25);

    padding-inline: 6px;

    display: flex;
    justify-content: center;
    align-items: center;

    height: 28px;
    width: 28px;

    margin-top: -11px;
}
.supplier-box {
    background: #e5e5e5;
    border-radius: 4px;

    padding-inline: 5px;

    font-weight: 600;
    font-size: 13px;
    line-height: 18px;

    display: flex;

    justify-content: space-between;
    align-items: center;

    color: #707070;

    height: 32px;

    margin-right: 20px;
}
.supplier-list-container-mobile .supplier-box {
    min-width: 10rem;
    padding-inline: 8px !important;
}
.mobile-btn {
    justify-content: center !important;
}
</style>
